import { render, staticRenderFns } from "./SobotAgents.vue?vue&type=template&id=20aae47e"
import script from "./SobotAgents.vue?vue&type=script&lang=js"
export * from "./SobotAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports